import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ReliabilityDashboardLayer from "../components/dashboards/ReliabilityDashboardLayer";

const ReliabilityDashboardPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Reliability Dashboard">
        <ReliabilityDashboardLayer />
      </MasterLayout>
    </>
  );
};

export default ReliabilityDashboardPage;
